import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCommissionConfigsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CommissionConfigDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CommissionConfigDocumentSortInput> | Types.CommissionConfigDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCommissionConfigsQuery = { __typename?: 'Query', commissionConfigs?: { __typename?: 'CommissionConfigsConnection', totalCount: number, nodes?: Array<{ __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMyCommissionConfigQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type GetMyCommissionConfigQuery = { __typename?: 'Query', commissionConfig?: { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> } | null };

export type GetUsersForCommissionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.UserDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserDocumentSortInput> | Types.UserDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetUsersForCommissionsQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, roles: Array<Types.UserRole>, status: Types.UserStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type CommissionUserLookupFragment = { __typename?: 'UserDocument', id: string, userId: string, fullName: string, email: string, roles: Array<Types.UserRole>, status: Types.UserStatus };

export type CommissionConfigFragment = { __typename?: 'CommissionConfigDocument', id: string, commissionConfigId: string, userId: string, defaultRatePercent: number, lastModified: Types.TDateISO, customerOverrides: Array<{ __typename?: 'CustomerCommissionOverrideData', customerId: string, ratePercent: number, customer?: { __typename?: 'CustomersSummaryDocument', customerId: string, name: string } | null }> };

export const CommissionUserLookupFragmentDoc = new TypedDocumentString(`
    fragment CommissionUserLookup on UserDocument {
  id
  userId
  fullName
  email
  roles
  status
}
    `, {"fragmentName":"CommissionUserLookup"});
export const CommissionConfigFragmentDoc = new TypedDocumentString(`
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}
    `, {"fragmentName":"CommissionConfig"});
export const GetCommissionConfigsDocument = new TypedDocumentString(`
    query GetCommissionConfigs($where: CommissionConfigDocumentFilterInput, $order: [CommissionConfigDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  commissionConfigs(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...CommissionConfig
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetMyCommissionConfigDocument = new TypedDocumentString(`
    query GetMyCommissionConfig($userId: String!) {
  commissionConfig(userId: $userId) {
    ...CommissionConfig
  }
}
    fragment CommissionConfig on CommissionConfigDocument {
  id
  commissionConfigId
  userId
  defaultRatePercent
  lastModified
  customerOverrides {
    customerId
    ratePercent
    customer {
      customerId
      name
    }
  }
}`);
export const GetUsersForCommissionsDocument = new TypedDocumentString(`
    query GetUsersForCommissions($where: UserDocumentFilterInput, $order: [UserDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  users(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...CommissionUserLookup
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment CommissionUserLookup on UserDocument {
  id
  userId
  fullName
  email
  roles
  status
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCommissionConfigs: build.query<GetCommissionConfigsQuery, GetCommissionConfigsQueryVariables | void>({
      query: (variables) => ({ document: GetCommissionConfigsDocument, variables })
    }),
    GetMyCommissionConfig: build.query<GetMyCommissionConfigQuery, GetMyCommissionConfigQueryVariables>({
      query: (variables) => ({ document: GetMyCommissionConfigDocument, variables })
    }),
    GetUsersForCommissions: build.query<GetUsersForCommissionsQuery, GetUsersForCommissionsQueryVariables | void>({
      query: (variables) => ({ document: GetUsersForCommissionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCommissionConfigsQuery, useLazyGetCommissionConfigsQuery, useGetMyCommissionConfigQuery, useLazyGetMyCommissionConfigQuery, useGetUsersForCommissionsQuery, useLazyGetUsersForCommissionsQuery } = injectedRtkApi;
